import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Quotes = (props: IIcon) => {
  const { className = '', ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-9 h-9', className)}
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.75 4.83154H33.25C33.8799 4.83154 34.484 5.08177 34.9294 5.52716C35.3748 5.97256 35.625 6.57665 35.625 7.20654V16.7065C35.625 17.3364 35.3748 17.9405 34.9294 18.3859C34.484 18.8313 33.8799 19.0815 33.25 19.0815H26.125C26.125 24.3208 30.3857 28.5815 35.625 28.5815V33.3315C27.7661 33.3315 21.375 26.9404 21.375 19.0815V7.20654C21.375 6.57665 21.6252 5.97256 22.0706 5.52716C22.516 5.08177 23.1201 4.83154 23.75 4.83154V4.83154ZM4.75 4.83154H14.25C14.8799 4.83154 15.484 5.08177 15.9294 5.52716C16.3748 5.97256 16.625 6.57665 16.625 7.20654V16.7065C16.625 17.3364 16.3748 17.9405 15.9294 18.3859C15.484 18.8313 14.8799 19.0815 14.25 19.0815H7.125C7.125 24.3208 11.3857 28.5815 16.625 28.5815V33.3315C8.76612 33.3315 2.375 26.9404 2.375 19.0815V7.20654C2.375 6.57665 2.62522 5.97256 3.07062 5.52716C3.51602 5.08177 4.12011 4.83154 4.75 4.83154V4.83154Z"
        fill="#3F8E58"
      />
    </svg>
  );
};

export default Quotes;
